import { types } from 'mobx-state-tree';
import CartProduct from '../../cart/CartProduct';
import Storage from '../../Storage';

const OrderCheckoutProduct = types
  .compose(CartProduct, types.model("OrderCheckoutProduct", {
    availability_html: types.maybeNull(types.string),
    quantity_error: types.maybeNull(types.string),
    short_description: types.maybeNull(types.string),
    storages: types.array(types.model({
      storageId: types.reference(Storage),
      quantity: types.integer,
      actualProcessingTime: types.integer,
    })),
  }))
  .named('OrderCheckoutProduct')
  .actions((self) => ({
    updateQuantity(newQuantity) {
      self.quantity = newQuantity;
    },
  }));

export default OrderCheckoutProduct;
